var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project && _vm.project.pages.length>1)?_c('div',{staticClass:"pager"},[_c('div',{staticClass:"counter"},[_c('div',{staticClass:"num number"},[_vm._v(_vm._s(_vm.$route.params.page))]),_c('div',{staticClass:"slash"},[_vm._v("/")]),_c('div',{staticClass:"tot number"},[_vm._v(_vm._s(_vm.project.pages.length))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c67859","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pager.vue
// module id = 34
// module chunks = 0